import { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ProductDetailsButton } from '../ProductDetailsButton';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsAddToBagButton = (props: Props) => {
  const { formatMessage } = useIntl();

  return (
    <ProductDetailsButton accessibilityLabel={formatMessage(messages.title)} {...props}>
      {formatMessage(messages.title)}
    </ProductDetailsButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Add to bag',
    description: 'Product Details | Add to bag button | Title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Omit<ComponentProps<typeof ProductDetailsButton>, 'style' | 'children'>;
